import type { ReactNode } from 'react';
import { Text } from '../text';

interface ErrorMessageProps {
  className?: string;
  text?: ReactNode;
}

export const ErrorMessage = (props: ErrorMessageProps) => {
  if (!props.text) return null;
  return (
    <Text className={props.className} size='xs' color='red'>
      {props.text}
    </Text>
  );
};
